module.exports = __webpack_public_path__ + "img/chr_ts_22_penlight.d87687bf.png";